import { useTheme } from '../lib/theme';
import styles from './ModeToggle.module.css';

export function ModeToggle() {
  const { mode, setMode } = useTheme();
  return (
    <nav className={styles.toggle} aria-label="Режим отображения">
      <button
        className={mode === 'day' ? styles.active : ''}
        onClick={() => setMode('day')}
        aria-pressed={mode === 'day'}
      >
        День
      </button>
      <button
        className={mode === 'night' ? styles.active : ''}
        onClick={() => setMode('night')}
        aria-pressed={mode === 'night'}
      >
        Ночь
      </button>
    </nav>
  );
}
